import { c as _c } from "react/compiler-runtime";
import { PortfolioRoomsResult } from "@/components/modules/portfolio/hooks/usePortfolioUtils";
import { useModal } from "@/components/providers/modal-provider/ModalProvider";
import { StepperForm } from "@/components/organisms/StepperForm/StepperForm";
import { useAssociateListingStepper } from "./useAssociateListingStepper";
type Props = {
  resource: PortfolioRoomsResult;
  listingId?: string;
  currentUnitId?: string | null;
  onSuccess?: () => void;
};
export function AssociateListingToUnitModal(t0) {
  const $ = _c(13);
  const {
    resource,
    listingId,
    currentUnitId,
    onSuccess
  } = t0;
  const {
    closeModal
  } = useModal();
  let t1;
  if ($[0] !== currentUnitId || $[1] !== listingId || $[2] !== onSuccess || $[3] !== resource) {
    t1 = {
      resource,
      listingId,
      currentUnitId,
      onSuccess
    };
    $[0] = currentUnitId;
    $[1] = listingId;
    $[2] = onSuccess;
    $[3] = resource;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    form,
    steps,
    handleOnSubmit,
    submitButtonText,
    isSubmitting,
    primaryActionDisabled
  } = useAssociateListingStepper(t1);
  let t2;
  if ($[5] !== closeModal || $[6] !== form || $[7] !== handleOnSubmit || $[8] !== isSubmitting || $[9] !== primaryActionDisabled || $[10] !== steps || $[11] !== submitButtonText) {
    t2 = <StepperForm form={form} steps={steps} handleOnSubmit={handleOnSubmit} submitButtonText={submitButtonText} isSubmitting={isSubmitting} primaryActionDisabled={primaryActionDisabled} onClose={closeModal} data-sentry-element="StepperForm" data-sentry-component="AssociateListingToUnitModal" data-sentry-source-file="AssociateListingToUnitModal.tsx" />;
    $[5] = closeModal;
    $[6] = form;
    $[7] = handleOnSubmit;
    $[8] = isSubmitting;
    $[9] = primaryActionDisabled;
    $[10] = steps;
    $[11] = submitButtonText;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}